var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 14.5C13.6046 14.5 14.5 13.6046 14.5 12.5C14.5 11.3954 13.6046 10.5 12.5 10.5C11.3954 10.5 10.5 11.3954 10.5 12.5C10.5 13.6046 11.3954 14.5 12.5 14.5ZM16.5 12.5C16.5 14.7091 14.7091 16.5 12.5 16.5C10.2909 16.5 8.5 14.7091 8.5 12.5C8.5 10.2909 10.2909 8.5 12.5 8.5C14.7091 8.5 16.5 10.2909 16.5 12.5Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.5C16.7425 6.5 16.0499 6.072 15.7111 5.39443L15.5403 5.05279C15.3709 4.714 15.0247 4.5 14.6459 4.5H10.3541C9.97533 4.5 9.62907 4.714 9.45967 5.05279L9.28885 5.39443C8.95007 6.072 8.25754 6.5 7.5 6.5H5.5C4.94772 6.5 4.5 6.94772 4.5 7.5V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5H19.5C20.0523 18.5 20.5 18.0523 20.5 17.5V7.5C20.5 6.94772 20.0523 6.5 19.5 6.5H17.5ZM17.5 4.5L17.3292 4.15836C16.821 3.14201 15.7822 2.5 14.6459 2.5H10.3541C9.21779 2.5 8.179 3.14201 7.67082 4.15836L7.5 4.5H5.5C3.84315 4.5 2.5 5.84315 2.5 7.5V17.5C2.5 19.1569 3.84315 20.5 5.5 20.5H19.5C21.1569 20.5 22.5 19.1569 22.5 17.5V7.5C22.5 5.84315 21.1569 4.5 19.5 4.5H17.5Z",
    fill: "#FF1C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 9.55228 18.5523 10 18 10C17.4477 10 17 9.55228 17 9C17 8.44772 17.4477 8 18 8C18.5523 8 19 8.44772 19 9Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.21349fc05b79175428168d6ae7742f0d.svg";
export { ForwardRef as ReactComponent };